const CheckLibList = resolve =>
  require(['src/views/check/CheckLibList.vue'], resolve)
// 工具页面
const ToolPage = resolve => require(['src/views/tools/ToolPage'], resolve)
// 功能页面
// import LandingPage from 'src/views/landing/LandingPage'
const LoginPage = resolve => require(['src/views/login/Login'], resolve)
const CollectPage = resolve => require(['src/views/login/Collect'], resolve)

const otherRouters = [
  {
    name: '信息收集',
    path: '/collect',
    component: CollectPage,
  },
  {
    name: '审核页面',
    path: '/admin',
    component: CheckLibList,
  },
  {
    name: '工具',
    path: '/tools/JSON',
    component: ToolPage,
  },
  {
    path: '/login',
    component: LoginPage,
  },
]
export default otherRouters
